import React, { Component } from 'react'
import { connect } from 'react-redux'
import CardLookUpSample from '../samples/CardLookUpSample'
import { makeCardLookupRequest } from '../../../actions/threeDSTwoActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _3DS2, _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const OBJECT = [ "mpiCardLookup", "mpiCardLookup", "$mpiCardLookup"]
const METHODS = {
    order_id: [ ".SetOrderId(order_id);", ".setOrderId(order_id);", "'order_id'=>$order_id"],
    credit_card_number: [ ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    data_key: [ ".SetData(data_key);", ".setData(data_key);", "'data_key'=>$data_key"],
    notification_URL: [".SetNotificationURL(\"HTTPS://YOURURL.COM\");", ".setNotificationURL(\"HTTPS://YOURURL.COM\");", "->setNotificationURL(\"HTTPS://YOURURL.COM\");"],
    store_id: [ ".SetStoreId(store_id);", ".setStoreId(store_id);", "'store_id'=>$store_id"],
    api_token: [ ".SetApiToken(api_token);", ".setApiToken(api_token);", "'api_token'=>$api_token"],
}

class ImplementingCardLookupRequest extends Component {
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    async onMakeCardLookUpRequestPress() {
        if(this.props.loading) return;
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _3DS2, orderId: newOrderId });
        const { storeId, apiToken, order_id, pan, notification_url } = this.props;
        const cardLookupRequest = { storeId, apiToken, order_id, pan, notification_url };
        this.props.makeCardLookupRequest(cardLookupRequest);
    }

    renderInteractiveTool() {
        const { loading } = this.props;

        return (
            <div className="stepMainContainer">
                <h3>Sample CardLook Up Request</h3>
                <CardLookUpSample />
                <div className={loading ? "disabledButton" : "requestButton"} onClick={() => this.onMakeCardLookUpRequestPress()}>
                    CardLook Up Request
                </div>
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>Implementing Card Lookup Request</b></span>
                <p style={{marginTop: '5vh'}}>
                    The CardLookup request verifies the applicability of 3DS 2.2 on the card and returns the 3DS Method URL. That is
                    used for device fingerprinting. This request is optional, it may increase the chance of a frictionless flow.
                </p>
                <p>
                    The <i>threeDSMethodURL &amp; threeDSMethodData</i> are returned to the merchant server on the CardLookup
                    response. The threeDSMethodData can be transmitted to the threeDSMethodURL via a browser post in order to
                    supplement the authentication request with device data pertaining to the cardholder’s browser.
                </p>
                <p>The threeDSMethodData must be sent via HTTP POST to the threeDSMethodURL in a hidden iFrame.</p>
                <p>In your implementation, use the following URLs as Host, depending on the development stage:</p>

                <p>Testing: <b>esqa.moneris.com</b></p>
                <p>Production: <b>www3.moneris.com</b></p>

                <h3 style={{ marginTop: '7vh', color: '#00a1cb'}}>Card Lookup Request – mpiCardLookup</h3>
                <p><b>Card Lookup Request transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>MpiCardLookup mpiCardLookup = new MpiCardLookup();</code>
                    case _JAVA:
                        return <code>MpiCardLookup mpiCardLookup = new MpiCardLookup();</code>
                    case _PHP:
                        return <code>$mpiCardLookup = new MpiCardLookup();</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for Card Lookup Request transaction</b></p>
                {(() => {
                    switch(progLangId) {
                        case _DOTNET:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(mpiCardLookup);</code>
                        case _JAVA:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(mpiCardLookup);</code>
                        case _PHP:
                            return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgTxn = new mpgTransaction($mpiCardLookup);</code>
                        default:
                            return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table className='four_cols_table'>
                    <th>Variable Name</th>
                    <th>Description</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td>Unique identifier provided by Moneris upon merchant account setup</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}<br />{METHODS.store_id[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>API token</td>
                        <td>Unique alphanumeric string assigned by Moneris upon merchant account activation</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}<br />{METHODS.api_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Card Lookup Request transaction request fields – Required</h3>
                <div style={{ width: '80%',backgroundColor: '#9df0ef', padding: '2px 10px', border: '1px solid #000', borderRadius: '10px' ,marginBottom: '5vh', marginTop: '5vh', marginRight: '2vw' }}>
                    <p style={{ color: '#000'}}><strong>NOTE: </strong>Either a pan or a data_key must be passed in the request</p>
                </div>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br /> 50-character alphanumerica-Z A-Z 0-9 _ - : . @ spaces</td>
                        <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.order_id[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>credit card number</td>
                        <td><i>String</i><br /><br /> max 20-character alphanumeric</td>
                        <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.credit_card_number[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>data key</td>
                        <td><i>String</i><br /><br /> 25-character alphanumeric</td>
                        <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.data_key[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>notification URL</td>
                        <td><i>String</i><br /><br /> 256-character alphanumeric</td>
                        <td><code>{OBJECT[progLangId]}{METHODS.notification_URL[progLangId]}</code></td>
                    </tr>
                </table>
            </div>
        )
    }

    render() {
        const { mode, selectedStep } = this.props;
        if(mode === 'interactive_tool' && selectedStep === 3)
            return this.renderInteractiveTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
  const { storeId, apiToken, order_id, pan, notification_url } = state.threeDSTwo.main.config;
  const { loading } = state.threeDSTwo.main;
  const { mode } = state.common.sideNav;
  const { selection } = state.threeDSTwo.stepsList;
  return { selectedStep: selection, mode, loading, storeId, apiToken, order_id, pan, notification_url, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makeCardLookupRequest, updateOrderId})(ImplementingCardLookupRequest)
